import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";

import { LangProvider } from "@/lib/i18n";

const Horoscope = lazy(() => import("@/pages/Horoscope"));
const Book = lazy(() => import("@/pages/Book"));
const Confirmation = lazy(() => import("@/pages/Confirmation"));
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const Admin = lazy(() => import("@/pages/Admin"));
const Reviews = lazy(() => import("@/pages/Reviews"));
const ConfirmByLink = lazy(() => import("@/pages/ConfirmByLink"));
const Today = lazy(() => import("@/pages/Today"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const KundliMilan = lazy(() => import("@/pages/KundliMilan"));
const About = lazy(() => import("@/pages/About"));
const DeleteData = lazy(() => import("@/pages/DeleteData"));
const page = (El) => <Suspense fallback={<div className="min-h-[60vh]" />}><El /></Suspense>;
const BookKeyed = () => <Book key={useLocation().search} />;

function App() {
  return (
    <LangProvider>
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/today" element={page(Today)} />
            <Route path="/horoscope" element={page(Horoscope)} />
            <Route path="/book" element={page(BookKeyed)} />
            <Route path="/booking/:id" element={page(Confirmation)} />
            <Route path="/admin/login" element={page(AdminLogin)} />
            <Route path="/reviews" element={page(Reviews)} />
            <Route path="/privacy" element={page(Privacy)} />
            <Route path="/kundli-milan" element={page(KundliMilan)} />
            <Route path="/about" element={page(About)} />
            <Route path="/delete-data" element={page(DeleteData)} />
            <Route path="/confirm/:token" element={page(ConfirmByLink)} />
            <Route path="/admin" element={page(Admin)} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
    </LangProvider>
  );
}

export default App;
